"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function sys(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M13.5345 11.3272C13.5188 11.324 13.5025 11.3252 13.4875 11.3306C13.4724 11.3361 13.4591 11.3455 13.449 11.3579C13.4421 11.3666 13.4371 11.3766 13.4342 11.3873C13.4313 11.398 13.4306 11.4092 13.4323 11.4202C13.4339 11.4312 13.4377 11.4417 13.4436 11.4511C13.4494 11.4605 13.4571 11.4686 13.4662 11.4749C16.7505 13.8584 12.0758 19.3154 3 13.5082C10.695 20.7494 21.4102 12.7507 13.5345 11.3272ZM9.1515 8.14119C2.337 10.3214 10.1438 15.4634 10.821 12.8662C10.824 12.8554 10.8248 12.844 10.8232 12.8329C10.8217 12.8217 10.8179 12.811 10.8121 12.8014C10.8062 12.7917 10.7985 12.7834 10.7893 12.7769C10.7802 12.7704 10.7698 12.7658 10.7587 12.7634C10.743 12.7593 10.7264 12.7596 10.7108 12.7642C9.708 13.0904 4.185 11.5462 9.15075 8.14119H9.1515ZM21 9.45144C15.0997 5.24394 4.029 8.71344 9.74025 11.6842C9.76066 11.6945 9.78425 11.6966 9.80616 11.6901C9.82807 11.6835 9.84663 11.6688 9.858 11.6489C9.86403 11.6377 9.86738 11.6252 9.86777 11.6125C9.86816 11.5997 9.86558 11.587 9.86025 11.5754C7.5375 6.66744 19.3358 8.15994 21 9.45144ZM16.104 15.5647C19.2232 14.1472 16.6867 9.29394 12.561 10.2307C12.5388 10.2357 12.5156 10.2318 12.4963 10.2199C12.4769 10.208 12.463 10.189 12.4575 10.1669C12.4539 10.1518 12.4549 10.1359 12.4602 10.1212C12.4655 10.1066 12.475 10.0938 12.4875 10.0844C15.6975 7.67244 21.723 13.3034 16.104 15.5647Z", fill: color }));
}
exports["default"] = sys;
//# sourceMappingURL=sys.js.map